// @flow

import * as R from "ramda";
import * as modals from "../constants/modals";

const initialState = {
    admins: { data: {}, error: null },
    celebrations: { data: {}, error: null },
    eventInfo: { data: {}, error: null },
    faqs: { data: {}, error: null },
    init: { isInitialized: false, error: null, dataListenersInitialized: null, dataListenersError: null },
    messages: { success: null, error: null },
    modals: { data: R.map(R.F)(modals), error: null },
    session: {
        error: null,
        userIsLoggedIn: false,
        isInitialized: false,
        isAuthenticated: false,
        isPasswordResetSuccessful: null,
        user: { uid: null }
    },
    settings: {},
    supplyDistributionSites: { data: {}, error: null },
    teams: { data: {}, error: null },
    teamMembers: { data: {}, error: null },
    tools: {
        towns: null,
        trashCollectionSites: null,
        celebrations: null,
        supplyDistributionSites: null,
        error: null,
        isBusy: false
    },
    towns: { data: {}, error: null },
    trashCollectionSites: { data: {}, error: null },
    trashDrops: { data: {}, error: null },
    users: { data: {}, error: null }
};


export default initialState;
